import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IManagerState, IManager } from '../../models/Manager';

const initialState: IManagerState = {
	list: [],
	isLoading: false,
	error: null,
};

const managerSlice = createSlice({
	name: 'managers',
	initialState,
	reducers: {
		setList: (state, action: PayloadAction<IManager[]>) => {
			state.list = action.payload;
		},
		setIsLoading: (state, action: PayloadAction<boolean>) => {
			state.isLoading = action.payload;
		},
		setErrorTrigger: (state, action: PayloadAction<any>) => {
			state.error = action.payload;
		},
		clearManagers: (state) => {
			state.list = [];
			state.error = null;
			state.isLoading = false;
		},
	},
});

export const { setList, setIsLoading, setErrorTrigger, clearManagers } = managerSlice.actions;

export default managerSlice.reducer;
